import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconWindowaccountup24pxRegular = function IconWindowaccountup24pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.087 16.952a2.44 2.44 0 013.878-.439.75.75 0 101.09-1.03 3.941 3.941 0 00-6.804 2.71.75.75 0 001.057.682l1.087-.489a.75.75 0 00-.308-1.434zm5.666.587a.75.75 0 01.38.652 3.941 3.941 0 01-6.741 2.775.75.75 0 111.065-1.056 2.438 2.438 0 003.726-.306.749.749 0 01-.3-1.39l1.115-.666a.75.75 0 01.755-.009z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3.75a8.25 8.25 0 100 16.5.75.75 0 010 1.5c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75a.75.75 0 01-1.5 0A8.25 8.25 0 0012 3.75z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM8.25 10a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 16.75a1.75 1.75 0 00-1.75 1.75.75.75 0 01-1.5 0 3.25 3.25 0 013.25-3.25h5a.75.75 0 010 1.5h-5z"
    })]
  }));
};
export default IconWindowaccountup24pxRegular;